(function () {
  if (window.imocoVideoBound) return;
  window.imocoVideoBound = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.imoco-video__start');
    if (!button) return;
    var player = button.closest('[data-imoco-video]');
    var id = player && player.dataset.imocoVideo;
    if (!id || !/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
    var frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?rel=0';
    frame.title = player.dataset.imocoTitle || 'Video Imoco Volley';
    frame.allow = 'encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    player.replaceChildren(frame);
    frame.focus();
  });
}());
